import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { Fieldset } from '../../../../vault.types';
import Citizenships from './components/citizenships';
import CountryOfBirth from './components/country-of-birth';
import Nationality from './components/nationality';
import SSN from './components/ssn';
import State from './components/state';
import UsLegalStatus from './components/us-legal-status';
import VisaKind from './components/visa-kind';
type CustomFieldProp = {
  di: DataIdentifier;
  entity: Entity;
};
const useFieldsets = includeNationality => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.user.vault"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let fieldsets;
  if ($[1] !== includeNationality || $[2] !== t) {
    fieldsets = {
      basic: {
        title: t(_temp),
        fields: [{
          di: "id.first_name"
        }, {
          di: "id.middle_name"
        }, {
          di: "id.last_name"
        }, {
          di: "id.email"
        }, {
          di: "id.phone_number"
        }]
      },
      identity: {
        title: t(_temp2),
        fields: [{
          di: "id.itin",
          renderCustomField: _temp3
        }, {
          di: "id.ssn9",
          renderCustomField: _temp4
        }, {
          di: "id.ssn4",
          renderCustomField: _temp5
        }, {
          di: "id.dob"
        }]
      },
      address: {
        title: t(_temp6),
        fields: [{
          di: "id.country"
        }, {
          di: "id.address_line1"
        }, {
          di: "id.address_line2"
        }, {
          di: "id.city"
        }, {
          di: "id.zip"
        }, {
          di: "id.state",
          renderCustomField: _temp7
        }]
      },
      usLegalStatus: {
        title: t(_temp8),
        fields: [{
          di: "id.us_legal_status",
          renderCustomField: _temp9
        }, {
          di: "id.nationality",
          renderCustomField: _temp10
        }, {
          di: "id.citizenships",
          renderCustomField: _temp11
        }, {
          di: "id.visa_kind",
          renderCustomField: _temp12
        }, {
          di: "id.visa_expiration_date"
        }]
      },
      investorProfile: {
        title: t(_temp13),
        fields: [{
          di: "investor_profile.employment_status"
        }, {
          di: "investor_profile.occupation"
        }, {
          di: "investor_profile.employer"
        }, {
          di: "investor_profile.annual_income"
        }, {
          di: "investor_profile.net_worth"
        }, {
          di: "investor_profile.investment_goals"
        }, {
          di: "investor_profile.risk_tolerance"
        }, {
          di: "document.finra_compliance_letter"
        }, {
          di: "investor_profile.declarations"
        }, {
          di: "investor_profile.brokerage_firm_employer"
        }, {
          di: "investor_profile.funding_sources"
        }, {
          di: "investor_profile.senior_executive_symbols"
        }, {
          di: "investor_profile.family_member_names"
        }, {
          di: "investor_profile.political_organization"
        }, {
          di: "document.finra_compliance_letter"
        }]
      },
      documents: {
        title: t(_temp14),
        fields: []
      },
      custom: {
        title: t(_temp15),
        fields: []
      }
    };
    if (includeNationality) {
      fieldsets.identity.fields.push({
        di: "id.nationality",
        renderCustomField: _temp16
      });
    }
    $[1] = includeNationality;
    $[2] = t;
    $[3] = fieldsets;
  } else {
    fieldsets = $[3];
  }
  return fieldsets;
};
export default useFieldsets;
function _temp($) {
  return $.basic.title;
}
function _temp2($_0) {
  return $_0.identity.title;
}
function _temp3(t0) {
  const {
    di,
    entity
  } = t0;
  return <SSN di={di} entity={entity} />;
}
function _temp4(t0) {
  const {
    di: di_0,
    entity: entity_0
  } = t0;
  return <SSN di={di_0} entity={entity_0} />;
}
function _temp5(t0) {
  const {
    di: di_1,
    entity: entity_1
  } = t0;
  return <SSN di={di_1} entity={entity_1} />;
}
function _temp6($_1) {
  return $_1.address.title;
}
function _temp7(t0) {
  const {
    di: di_2,
    entity: entity_2
  } = t0;
  return <State di={di_2} entity={entity_2} />;
}
function _temp8($_2) {
  return $_2.usLegalStatus.title;
}
function _temp9(t0) {
  const {
    di: di_3,
    entity: entity_3
  } = t0;
  return <UsLegalStatus di={di_3} entity={entity_3} />;
}
function _temp10(t0) {
  const {
    di: di_4,
    entity: entity_4
  } = t0;
  return <CountryOfBirth di={di_4} entity={entity_4} />;
}
function _temp11(t0) {
  const {
    di: di_5,
    entity: entity_5
  } = t0;
  return <Citizenships di={di_5} entity={entity_5} />;
}
function _temp12(t0) {
  const {
    di: di_6,
    entity: entity_6
  } = t0;
  return <VisaKind di={di_6} entity={entity_6} />;
}
function _temp13($_3) {
  return $_3.investorProfile.title;
}
function _temp14($_4) {
  return $_4.documents.title;
}
function _temp15($_5) {
  return $_5.custom.title;
}
function _temp16(t0) {
  const {
    di: di_7,
    entity: entity_7
  } = t0;
  return <Nationality di={di_7} entity={entity_7} />;
}